var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book-page-container"},[_c('TopNavbar',{attrs:{"title":"我的动态"}}),_c('MomentMine')],1)}
var staticRenderFns = []

export { render, staticRenderFns }